<template>
  <VBtn
    fab
    dark
    class="circle-icon no-print"
    @click="click"
    @mouseout="mouseout"
  >
    <PsIcon :icon="icon" />
  </VBtn>
</template>

<script>
export default {
    name: "PsIconButton",
    props: {
        click: {
            type: Function,
            required: false,
            default: () => {}
        },
        mouseout: {
            type: Function,
            required: false,
            default: () => {}
        },        
        icon: {
            type: String,
            required: false,
            default: "save"
        }
    },
    mounted()  {
   
        if (typeof(this.$parent) !== 'undefined'){
            if(this.$parent.$vnode.tag.indexOf("PsColumn") >= 0)
            {
                this.$el.remove();
            }
        }
    }
};
</script>
<style lang='scss'>
@import "../styles/ps-icon-button.scss";
</style>
